import {map, filter} from 'rxjs/operators';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ITableHeader} from '../../../../shared/table/TableComponent';
import {BehaviorSubject, Observable} from 'rxjs';

import {PagedListOfPledgeDetailReport} from '../../../../../services/api.client';
import {formatDate} from '../../../../../utilities/date-util';
import {DATE_TIME_FORMAT, SHORT_DATE_FORMAT} from '../../../../../constants';
import {PledgeReportForm} from '../../PledgeReportForm';
import {PledgeStatusType} from '../../../../../services/api.client';
import {splitCamelCase} from '../../../../../utilities/Util';
import {User} from '../../../../../services/api.client';
import {PledgeService} from '../../../../../services/PledgeService';
import {SecurityService} from '../../../../../services/SecurityService';

@Component({
    templateUrl: './AgencyDetailReportComponent.html',
    standalone: false
})
export class AgencyDetailReportComponent implements OnInit {

  constructor(public pledgeService: PledgeService,
              private _securityService: SecurityService) {
      this.currentUser$ = this._securityService.currentUser$;
  }
  tableHeaders: ITableHeader[] = [];
  rows: any;

  @ViewChild('form')
  form: PledgeReportForm;

  // subscription
  currentUser: User;
  currentUser$: Observable<User>;
  private readonly _report$ = new BehaviorSubject<PagedListOfPledgeDetailReport>(null);
  report$: Observable<PagedListOfPledgeDetailReport> = this._report$.asObservable();
  report: PagedListOfPledgeDetailReport;

  header: ITableHeader;

  ngOnInit(): void {
    this.currentUser$.subscribe(currentUser => this.currentUser = currentUser);
    if (this.currentUser.hasPrivate) {
        this.tableHeaders = [
            {text: 'Entry Date', sortKey: 'EnteredDate'},
            {text: 'Agency', sortKey: 'AgencyName'},
            {text: 'Pledges Type', sortKey: 'PledgeType'},
            {text: 'Assistance Type'},
            {text: 'Leverage'},
            {text: 'Status', sortKey: 'Status'},
            {text: 'PledgeID', sortKey: 'PledgeNumber'},
            {text: 'Company', sortKey: 'CompanyName'},
            {text: 'Acct#', sortKey: 'AccountNumber'},
            {text: 'First Name', sortKey: 'FirstName'},
            {text: 'Middle Initial', sortKey: 'MiddleName'},
            {text: 'Last Name', sortKey: 'LastName'},
            {text: 'Pledge Date', sortKey: 'PledgeDate'},
            {text: 'Amount$', sortKey: 'PledgeAmount'},
            {text: 'Approved By', sortKey: 'UwdaApprovedByName'},
            {text: 'Ledger #', sortKey: 'LedgerNumber'},
            {text: 'Private', sortKey: 'Private'},
            {text: 'Census Tract', sortKey: 'CensusTract'},
            {text: 'Address1', sortKey: 'Address1'},
            {text: 'Address2', sortKey: 'Address2'},
            {text: 'City', sortKey: 'City'},
            {text: 'State', sortKey: 'State'},
            {text: 'Zip Code', sortKey: 'ZipCode'},
            {text: 'County', sortKey: 'County'},
            {text: 'Special Coding', sortKey: 'SpecialCoding'},
            {text: 'Entered By Name', sortKey: 'EnteredByName'},
            {text: 'Entered By Email', sortKey: 'EnteredByEmail'},
        ];

      this.rows = this.report$.pipe(
        filter(report => !!report),
        map((report) => report.items.map(r => [
          formatDate(r.enteredDate, DATE_TIME_FORMAT),
          r.agencyName,
          r.pledgeType,
          this.getAssistanceType(r.assistanceType, r.isUwda),
          r.leverageAmount,
          this.getStatus(r.status),
          r.pledgeNumber,
          this.getCompanyName(r.companyName, r.onetimeCompanyRecipient),
          r.accountNumber,
          r.firstName,
          r.middleName,
          r.lastName,
          formatDate(r.pledgeDate, SHORT_DATE_FORMAT),
          r.pledgeAmount.toFixed(2),
          r.approvedBy,
          r.ledgerNumber,
          r.isPrivate,
            r.censusTract,
            r.address1,
            r.address2,
            r.city,
            r.state,
            r.zipCode,
            r.county,
            r.specialCoding,
            r.enteredByName,
            r.enteredByEmail
        ])), );

    } else {
        this.tableHeaders = [
            {text: 'Entry Date', sortKey: 'EnteredDate'},
            {text: 'Agency', sortKey: 'AgencyName'},
            {text: 'Pledges Type', sortKey: 'PledgeType'},
            {text: 'Assistance Type'},
            {text: 'Leverage'},
            {text: 'Status', sortKey: 'Status'},
            {text: 'PledgeID', sortKey: 'PledgeNumber'},
            {text: 'Company', sortKey: 'CompanyName'},
            {text: 'Acct#', sortKey: 'AccountNumber'},
            {text: 'First Name', sortKey: 'FirstName'},
            {text: 'Middle Initial', sortKey: 'MiddleName'},
            {text: 'Last Name', sortKey: 'LastName'},
            {text: 'Pledge Date', sortKey: 'PledgeDate'},
            {text: 'Amount$', sortKey: 'PledgeAmount'},
            {text: 'Approved By', sortKey: 'UwdaApprovedByName'},
            {text: 'Ledger #', sortKey: 'LedgerNumber'},
            {text: 'Census Tract', sortKey: 'CensusTract'},
            {text: 'Address1', sortKey: 'Address1'},
            {text: 'Address2', sortKey: 'Address2'},
            {text: 'City', sortKey: 'City'},
            {text: 'State', sortKey: 'State'},
            {text: 'Zip Code', sortKey: 'ZipCode'},
            {text: 'County', sortKey: 'County'},
            {text: 'Special Coding', sortKey: 'SpecialCoding'},
            {text: 'Entered By Name', sortKey: 'EnteredByName'},
            {text: 'Entered By Email', sortKey: 'EnteredByEmail'},
        ];

      this.rows = this.report$.pipe(
        filter(report => !!report),
        map((report) => report.items.map(r => [
          formatDate(r.enteredDate, DATE_TIME_FORMAT),
          r.agencyName,
          r.pledgeType,
          this.getAssistanceType(r.assistanceType, r.isUwda),
          r.leverageAmount,
          this.getStatus(r.status),
          r.pledgeNumber,
          this.getCompanyName(r.companyName, r.onetimeCompanyRecipient),
          r.accountNumber,
          r.firstName,
          r.middleName,
          r.lastName,
          formatDate(r.pledgeDate, SHORT_DATE_FORMAT),
          r.pledgeAmount.toFixed(2),
          r.approvedBy,
          r.ledgerNumber,
            r.censusTract,
            r.address1,
            r.address2,
            r.city,
            r.state,
            r.zipCode,
            r.county,
            r.specialCoding,
            r.enteredByName,
            r.enteredByEmail
        ])), );
    }
  }

  submitReport(): void {
      this.form.submitAgencyPledgeDetailReport()?.subscribe({
          next: (report) => {
              this.report = report;
              this._report$.next(report);
          },
          error: () => {}
      });
  }

  onHeaderClick(header: ITableHeader): void {
    this.header = header;
    this.form.submitAgencyPledgeDetailReport(this.report.offset, this.report.limit, this.header.sortKey, this.header.ascending)?.subscribe({
        next: (report) => {
            this.report = report;
            this._report$.next(report);
        },
        error: () => {}
    });
  }

  onTableUpdate(pagedList: PagedListOfPledgeDetailReport): void {
      const sortKey = this.header ? this.header.sortKey : null;
      const ascending = this.header && this.header.ascending;
      this.form.submitAgencyPledgeDetailReport(pagedList.offset, pagedList.limit, sortKey, ascending)?.subscribe({
          next: (report) => {
              this.report = report;
              this._report$.next(report);
          },
          error: () => {}
      });
  }

  private getStatus(status: number | string): string {
      if (typeof status === 'number') {
          return splitCamelCase(PledgeStatusType[status]);
      }
      return splitCamelCase(status);
  }

  private getAssistanceType(assistanceType: any, isUwda: any): string {
    if (isUwda) {// check if 211-DA pledge; if yes, show pledge assistance type
      const assType = this.pledgeService.formatPledgeAssistanceType(assistanceType);
      return splitCamelCase(assType);
    } else {
      return 'NONE';
    }
  }

  private getCompanyName(companyName: any, oneTimePayee: any): string {
    if (companyName) {// check if regular company
      return splitCamelCase(companyName);
    } else {
      return splitCamelCase(oneTimePayee); // one time company
    }
  }
}
